<template>
	<div class="tuNewList">
		<ul class="flexDiv">
			<li
				v-for="(item, index) in dataList"
				:key="item.ID"
				@mouseenter="hoverRoll(item)"
				class="wow fadeInLeft"
				:data-wow-delay="index / 9 + 's'"
			>
				<router-link
				:to="item.Url"
				:href="item.Url"
				@click.native="OpenLink(item.Url)"
				>
				<div class="New_img">
					<img :src="item.FileUrl" alt="">
				</div>
				<div class="textBox">
					<p class="title txt-cut1">{{ item.Title }}</p>
				</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'ImgList',
		props:{
			dataList:{
				type: Array,
				default: () => []
			},
			moreLink: {
			   type: String,
			   default: ''
			}
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			    this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
.tuNewList {
  width: 1200px;
  ul {
  width: 1200px;
  height: auto;
  flex-wrap: wrap !important;
  &::after{
	  content: "";
	  width: 347px;
  }
  li{
	  width: 347px;
	  height: 275px;
	  box-shadow: 0px 0px 5px 0px 
		rgba(6, 0, 1, 0.3);
	  margin: 0;
	  margin-bottom: 40px;
	  &:last-child,
	  &:nth-last-child(2),
	  &:nth-last-child(3){
		  margin-bottom: 0px;
	  }
	  &:hover{
		 .textBox{
			p{
			  color: #0376BE;
			}
		 } 
	  }
	  .New_img{
		  width: 347px;
		  height: 227px;
	  	}
	  	.textBox{
		  height: 48px;
		  padding: 0 10px;
		  box-sizing: border-box;
		  text-align: center;
			p{
				font-size: 18px;
				font-weight: normal;
				font-stretch: normal;
				line-height: 48px;
				letter-spacing: 2px;
				color: #333333;
			}
		}
	}
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ImgList.vue